import { AutogenModelP44ConfigProfileLookup, AutogenRowP44ConfigProfileLookup } from "./autogen/AutogenModelP44ConfigProfileLookup";

export class ModelP44ConfigProfileLookup extends AutogenModelP44ConfigProfileLookup<RowP44ConfigProfileLookup> {
	constructor() {
		super(RowP44ConfigProfileLookup);
	}
}

export class RowP44ConfigProfileLookup extends AutogenRowP44ConfigProfileLookup {
}